import { Controller } from 'react-hook-form';
import DropdownMultiSelect from '../../../../components/common/Dropdown/DropdownMultiSelect';
import { SelectOption } from '../../../../components/common/Dropdown/types';
import { FilterViewModel } from '../../../../types/domain';

type MultiSelectFilterProps = {
  filter: FilterViewModel;
  fieldName: string;
  control: any;
  selectedOptions?: SelectOption[];
  onSelectedOptionsChange?: (selectedOptions: SelectOption[]) => void;
};

export const MultiSelectFilter = ({ filter, fieldName, control, selectedOptions = [], onSelectedOptionsChange }: MultiSelectFilterProps) => {
  const staticOptions: SelectOption[] = filter.values || [];

  // If the filter provides autocomplete, use async loader.
  const loadOptions = filter.autocomplete && filter.autocompleteUrl ? async (input: string) => {
    // Build URL: append searchQuery param to whatever URL is provided (which may already contain other params)
    const base = filter.autocompleteUrl!;
    const separator = base.includes('?') ? '&' : '?';
    const url = `${base}${separator}searchQuery=${encodeURIComponent(input)}`;

    try {
      const res = await fetch(url, { method: 'GET' });

      if (!res.ok) {
        console.warn('Autocomplete GET failed', url, res.status, res.statusText);
        return [];
      }

      let payload = await res.json();

      if (!Array.isArray(payload)) return [];

      return payload.map((item: any) => {
        const value = item.id;
        const label = item.value;
        return { value, label, category: item.category ?? null } as any;
      });
    } catch (e) {
      console.error('Autocomplete load error for', filter.autocompleteUrl, e);
      return [];
    }
  } : undefined;



  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={[]}
      render={({ field }) => {
        return (
          <DropdownMultiSelect
            allOptionInResults={false}
            includeAllOption={!filter.autocomplete}
            options={staticOptions}
            loadOptions={loadOptions}
            cacheOptions={false}
            selected={selectedOptions}
            onChange={(newSelectedOptions: SelectOption[]) => {
              // Update the form field with values
              field.onChange(newSelectedOptions.map(o => o.value));
              
              // Update the parent component's selectedOptions state
              if (onSelectedOptionsChange) {
                onSelectedOptionsChange(newSelectedOptions);
              }
            }}
          />
        );
      }}
    />
  );
};